import {Component} from 'react';
import { reformatDateToDisplay } from '../../objects/CommonUse/reformatDateToDisplay_function';

class ThreeColumnRadioCard extends Component {
    constructor(props) {
        super(props);
        this.state = {  };
             // Bind the handler so 'this' refers to the component
        this.onChangeValue = this.onChangeValue.bind(this);
        this.checked = false;
    }

    onChangeValue(event){
        this.props.onSelect(event.target.value);
    }
  
    render() {
        let reformatDate = "";
        if (this.props.outInfo.dateAssigned){
            reformatDate = reformatDateToDisplay(this.props.outInfo.dateAssigned, "YYYY/MM/DD");
        } 
        let checked = false;
        if (this.props.outInfo.accountNbr === this.props.selectedAccountNbr){
            checked = true;
        }
        let rowClass = "";
        if (this.props.outInfo.accountNbr === this.props.currentAccountNbr){
            rowClass = "myTable-row-highlight"
        }
    return <>
      
       {this.props.infoType === "label-label-label" ?
            <tr className={rowClass}>
                <td>
                    <input type="radio" className="vertical-center" 
                        value={this.props.outInfo.accountNbr} name="site" 
                        onChange={this.onChangeValue}
                        checked={checked}/> 
                </td>
                <td className="vertical-center text-center p-0">{this.props.outInfo.accountNbr}</td>
                <td className="vertical-center text-center p-0">{this.props.outInfo.className}</td>
                <td className="vertical-center text-center p-0">{reformatDate}</td>
            </tr> 
        :
            null  
        }
    </>
    }

}

export default ThreeColumnRadioCard;